module.exports = __webpack_public_path__ + "static/media/ca-bobina2.0f07f14d.jpg";